import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/Builder/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_builder } from '../../../actions/v3/masterData'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_builder(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listBuilderMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Builder'}
            >
                <Form
                    title={'Add Builder'}
                    onSubmit={onSubmit}
                    buttonName={'Create Builder'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add